import React, { Fragment, useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { useParams, useHistory, Link } from 'react-router-dom';
import { fetchData, deleteData, activateData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

const UserTypeEdit = (props) => {
    const { id } = useParams();
    const recordId = useParams();
    const history = useHistory();
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false);


    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);
    const [formData, setFormData] = useState({
        name: '',
        code: '',
        isSubmit: false
    });

    useEffect(() => {
        fetchData('UserTypeApi', `/UserType/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    // Destructure the response to get response_data
                    const { response_data } = response;
                    // Set form data
                    setFormData(response_data);

                    // Update form data with converted dates
                    setFormData(prevFormData => ({
                        ...prevFormData,


                    }));
                }
            })
            .catch((error) => {
                console.error('Error fetching UserType Details:', error);
            });
    }, [id]);

    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'checkbox' ? !prevData[name] : value,
        }));
    };
    //   //search
    //   const filteredData = data.filter((item) =>
    //     Object.values(item).some((value) =>
    //       String(value).toLowerCase().includes(searchQuery.toLowerCase())
    //     )
    //   );
    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);

        // if (!formData.isSubmit) {
        //     return;
        // }

        setFormData(prevData => ({
            ...prevData,
            UpdatedBy: userId,
        }));

        // Validate form data here if needed

        updateData('UserTypeApi', `${id}`, formData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                history.push('/UserTypeIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
                setIsLoading(false);
            });
    };

    return (
        <Fragment>
            <div className="w-full max-w-sm container mt-2 mx-auto">
                <form onSubmit={handleSubmit}>

                    <div className='w-full mb-2 flex items-center'>
                        <h6 className='uppercase psheading flex-grow linkcolor' style={{ fontFamily: 'Times New Roman', color: 'black' }}>User Type - Edit</h6>
                        <Tooltip title="Exit">
                            <Link to="/UserTypeIndex" style={{ color: 'red', textDecoration: 'none', fontWeight: 'bolder' }}>
                                <Button style={{ color: 'red', fontWeight: 'bolder' }}>
                                    Back-To-List <ExitToAppIcon />
                                </Button>
                            </Link>
                        </Tooltip>


                        <Tooltip title="SAVE">

                            <Button onClick={handleSubmit} style={{ color: 'darkolivegreen', fontWeight: 'bolder', marginLeft: '2px' }} disabled={isLoading}>
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "UPDATE"} <CheckCircleIcon />
                            </Button>

                        </Tooltip>
                    </div>
                    {errorMessage && <p className="text-red-500">{errorMessage}</p>}
                    {successMessage && <p className="text-green-500">{successMessage}</p>}

                    <div className="w-full mb-4 flex">

                        <div className="w-1/2 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Name
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.name}
                                name="name"
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter UserType Name"
                            />

                        </div>

                        <div className="w-1/8 mr-2">
                            <label className="block uppercase text-black tracking-wide  text-xs font-bold mb-2" htmlFor="name">
                                Code
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.code}
                                name="code"
                                onChange={handleChange}
                                type="text"
                                placeholder="Enter Code"
                            />

                        </div>


                    </div>

                </form>
            </div>
        </Fragment>
    );
}

export default UserTypeEdit;

